import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4649bc0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "login-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-title" }, "Fazer Login", -1))
const _hoisted_5 = { class: "flex flex-center column q-mt-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_cube = _resolveComponent("q-spinner-cube")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "login-page" }, {
    default: _withCtx(() => [
      (_ctx.loadingIntegration)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_q_spinner_cube, {
              size: "50px",
              color: "green"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "background-image",
              style: _normalizeStyle(_ctx.bannerColor)
            }, [
              _createVNode(_component_q_img, {
                src: _ctx.area?.banner,
                style: {"height":"50vh"}
              }, null, 8, ["src"])
            ], 4),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_q_card, { class: "login-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, {
                    class: "login-header",
                    style: _normalizeStyle(_ctx.loginColor)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_img, {
                        src: _ctx.area?.login_logo,
                        class: "login-logo"
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  }, 8, ["style"]),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createVNode(_component_q_form, {
                        class: "q-gutter-y-sm",
                        onSubmit: _ctx.signIn,
                        onKeydown: _withKeys(_ctx.signIn, ["enter"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_input, {
                            filled: "filled",
                            label: "E-mail",
                            type: "email",
                            "data-cy": "user-email",
                            rules: [(v) => (!!v && _ctx.regEmail.test(v)) || _ctx.Messages.EMAIL_INPUT_ERROR],
                            modelValue: _ctx.user,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user) = $event))
                          }, null, 8, ["rules", "modelValue"]),
                          _createVNode(_component_q_input, {
                            type: _ctx.isPasswd ? 'password' : 'text',
                            color: _ctx.$q.dark.isActive ? 'white' : null,
                            name: "password",
                            rules: [(v) => !!v || "Digite a senha"],
                            "aria-label": "password",
                            label: "Senha",
                            "data-cy": "user-password",
                            filled: "filled",
                            modelValue: _ctx.password,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                            onKeyup: _withKeys(_ctx.signIn, ["enter"])
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                class: "cursor-pointer",
                                name: _ctx.isPasswd ? 'visibility_off' : 'visibility',
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPasswd = !_ctx.isPasswd))
                              }, null, 8, ["name"])
                            ]),
                            _: 1
                          }, 8, ["type", "color", "rules", "modelValue", "onKeyup"]),
                          _createVNode(_component_q_btn, {
                            class: "full-width",
                            label: "Entrar",
                            "data-cy": "login-btn",
                            push: "",
                            loading: _ctx.loading,
                            color: "green",
                            type: "submit"
                          }, null, 8, ["loading"])
                        ]),
                        _: 1
                      }, 8, ["onSubmit", "onKeydown"]),
                      _createElementVNode("div", _hoisted_5, [
                        (_ctx.hasRegisterModule())
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              icon: "check_circle",
                              dense: "dense",
                              push: "push",
                              glossy: "glossy",
                              style: {"width":"60%"},
                              label: "Cadastre-se grátis",
                              color: "blue-7",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/cadastro')))
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_q_btn, {
                          style: {"text-decoration":"underline"},
                          label: "Alterar senha",
                          "no-caps": "",
                          color: "grey-7",
                          flat: "",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/redefinir-senha')))
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_Transition, {
              appear: "",
              "enter-active-class": "animated bounceInUp"
            }, {
              default: _withCtx(() => [
                (_ctx.showContactButton)
                  ? (_openBlock(), _createBlock(_component_q_page_sticky, {
                      key: 0,
                      position: "bottom-right",
                      offset: [18, 18]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_btn, {
                          "data-cy": "custom-contact-buttom",
                          push: "push",
                          fab: "fab",
                          color: "green",
                          icon: "chat",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openURL(_ctx.area?.contact.url || '')))
                        }),
                        _createVNode(_component_q_tooltip, {
                          modelValue: _ctx.contactTooltip,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contactTooltip) = $event)),
                          anchor: "center left",
                          self: "center right",
                          "content-class": "bg-green text-body2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.area?.contact.label || ''), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_footer, { class: "bg-white" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_separator),
                _createVNode(_component_q_toolbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_toolbar_title, { class: "text-center text-body2 text-grey-7" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.area?.description || 'Mais Questões') + " © " + _toDisplayString(_ctx.year), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }))
}